import { render, staticRenderFns } from "./menu-service.vue?vue&type=template&id=45cc1237&"
import script from "./menu-service.vue?vue&type=script&lang=js&"
export * from "./menu-service.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports